// extracted by mini-css-extract-plugin
module.exports = {"smallPadd":"Quote_smallPadd__P_91p","text":"Quote_text__k8e0k"};